import { useSyncExternalStore } from "react";
import { usePlatformCapabilities } from "@shared-core/capabilities/context";

/** Whether a media query matches now, and again whenever it changes: the platform answers (a capability). */
export function useMediaQuery(query: string): boolean {
  const capabilities = usePlatformCapabilities();
  return useSyncExternalStore(
    (onChange) => capabilities.onMediaQueryChange(query, onChange),
    () => capabilities.matchesMediaQuery(query),
  );
}

/** Tailwind's `lg`: the quote's summary sits beside the page from here, and in a bar under it below. */
export const SUMMARY_BESIDE_PAGE = "(min-width: 1024px)";

/** Tailwind's `md`: the items list sits beside an item's detail from here (ItemsListDetail), two screens below it. */
export const ITEM_LIST_BESIDE_DETAIL = "(min-width: 768px)";
